import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import ExtendedTable from "components/Table";
import EmptyBlock from "components/EmptyBlock";
import { MenuItem } from "components/ActionMenu/types";

import IntegrationBanks from "./IntegrationBanks";
import IntegrationDeleteModal from "./IntegrationDeleteModal";
import IntegrationNameUpdateModal from "./IntegrationNameUpdateModal";

import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  BankToken,
  getBankIntegrations,
} from "store/features/bankIntegrationsSlice";

import { bankTokenColumns } from "shared/constants/ibanColumns";

import { ReactComponent as EditIcon } from "assets/images/actionMenu/edit-menu-icon.svg";
import { ReactComponent as DeleteIcon } from "assets/images/actionMenu/delete-menu-icon.svg";

const ApiTokenMain: React.FC = () => {
  const dispatch = useAppDispatch();
  const [contentLoading, setContentLoading] = useState(true);

  const [selectedIntegration, setSelectedIntegration] =
    useState<BankToken | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditNameModal, setShowEditNameModal] = useState(false);

  const banksIntegrations = useAppSelector(
    (state) => state.bankIntegrations.banks
  );

  useEffect(() => {
    // Fetch all bank integrations on tab click
    setContentLoading(true);
    dispatch(getBankIntegrations()).finally(() => setContentLoading(false));
  }, []);

  const onDeleteIntegration = (bank?: BankToken) => {
    bank && setSelectedIntegration(bank);
    setShowDeleteModal(true);
  };

  const onCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedIntegration(null);
  };

  const onEditIntegrationName = (bank?: BankToken) => {
    bank && setSelectedIntegration(bank);
    setShowEditNameModal(true);
  };

  const onCloseEditNameModal = () => {
    setShowEditNameModal(false);
    setSelectedIntegration(null);
  };

  const tableActions: MenuItem<BankToken>[] = [
    {
      id: "edit",
      name: "Назва",
      icon: EditIcon,
      action: onEditIntegrationName,
    },
    {
      id: "delete",
      name: "Видалити",
      icon: DeleteIcon,
      action: onDeleteIntegration,
    },
  ];

  return (
    <>
      <Box width="100%" sx={{ mb: { xs: 2, sm: 3 } }}>
        <Typography sx={{ mb: 0.5 }} variant="h3">
          Інтеграції
        </Typography>
        <Typography variant="body1" color="grey700">
          Всі створені інтеграції
        </Typography>
      </Box>
      <IntegrationBanks />

      {!contentLoading && banksIntegrations && banksIntegrations.length <= 0 ? (
        <EmptyBlock text="Ви ще не маєте жодної інтеграції з банками." />
      ) : (
        <ExtendedTable<BankToken>
          loading={contentLoading}
          columns={bankTokenColumns}
          rows={banksIntegrations || []}
          actions={tableActions}
        />
      )}

      <IntegrationDeleteModal
        isOpen={showDeleteModal}
        bankToken={selectedIntegration}
        onClose={onCloseDeleteModal}
      />
      <IntegrationNameUpdateModal
        isOpen={showEditNameModal}
        bankToken={selectedIntegration}
        onClose={onCloseEditNameModal}
      />
    </>
  );
};

export default ApiTokenMain;
